import Vuex from 'vuex'
import Vue from 'vue'
import axios from './lib/McAxios';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: null,
        inProgress: false,
        requestAddress: false,
        cart: {
            "tokenValue": null,
            "channel": "",
            "currency": "",
            "locale": "",
            "checkoutState": "",
            "items": [],
            "totals": {
                "total": 0,
                "items": 0,
                "taxes": 0,
                "shipping": 0,
                "promotion": 0
            },
            "payments": [],
            "shipments": [],
            "cartDiscounts": []
        },
        stripe: {
            spk:"pk_test_91FcdIE1t4EE2vhg8Ur3RRFo",
            stripe:undefined,
            card:undefined,
            reply:{},
            error: "",
            clientSecret: '',

        },
        paymentMethods: [],
        completeData: {
            'firstName': '',
            'lastName': '',
            'email': '',
            'notes': '',
            'phoneNumber': '',
            'pickup': '',
            'isComplete': false,
        },
        cachedCompleteData: false,
    },

    getters: {
    },

    mutations: {
        updateCart(state, cart) {
            state.inProgress = false
            if(!state.token) {
                state.token = cart.tokenValue
                sessionStorage.setItem('cartToken', state.token)
                if(!cart.shippingAddress || cart.shipments.length==0) {
                    state.requestAddress = true
                } else {
                    state.requestAddress = false
                }
            }
            state.cart = cart
            if (!state.cachedCompleteData) {
                if (cart.shippingAddress) {
                    state.completeData.firstName = cart.shippingAddress.firstName
                    state.completeData.lastName = cart.shippingAddress.lastName
                    state.completeData.phoneNumber = cart.shippingAddress.phoneNumber
                }
            }
            for (let i=0; i<state.cart.items.length; i++) {
                state.cart.items[i].varText = ''
                for (let j=0; j<state.cart.items[i].product.variants.length; j++) {
                    let varText = ''
                    for (let x=0; x<state.cart.items[i].product.variants[j].axis.length; x++) {
                        if (x>0) { varText = varText + '<br>' }
                        varText = varText + state.cart.items[i].product.variants[j].nameAxis[state.cart.items[i].product.variants[j].axis[x]]
                    }
                    state.cart.items[i].varText = varText
                }
            }
            if ( state.cart.shipments.length > 0 && state.cart.shippingAddress ) {
                axios.get('/shop-api/checkout/'+state.token+'/payment')
                    .then( response => {
                        state.paymentMethods = response.data.payments

                    })
                    .catch(()=>{
                        state.paymentMethods = []
                    })

            }
        },
        changeProgress( state, progress ) {
            state.inProgress = progress
        },
        toggleDelivery( state, toggle) {
            state.requestAddress = toggle
        },
        changeCompleteData (state, data) {
            state.completeData = data
            state.cachedCompleteData = true
            if (!(typeof state.completeData.lastName == 'undefined' || state.completeData.lastName.length==0)
                || (typeof state.completeData.phoneNumber == 'undefined' || state.completeData.phoneNumber.length==0)
                || (typeof state.completeData.email == 'undefined' || state.completeData.email.length==0) ) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(state.completeData.email))
                {
                    state.completeData.isComplete = true
                } else {
                    state.completeData.isComplete = false
                }
            } else {
                state.completeData.isComplete = false
            }
        },
        initStripePayment (state, el) {
            state.stripe.stripe= window.Stripe(state.stripe.spk);
            state.stripe.card = state.stripe.stripe.elements().create('card');
            state.stripe.card.mount(el);
        },
        setStripeError (state, message) {
            state.stripe.error= message;
        },
        setStripeReply (state, reply) {
            state.stripe.reply= reply;
        },
        setStripeClientSecret (state, cs) {
            state.stripe.clientSecret= cs;
        },
        setPickupTime (state, t) {
            state.completeData.pickup = t;
        },
    },

    actions: {
        addProduct(context, productCode) {
            if (productCode.length>1) {
                this.purchase = {
                    productCode: productCode[0],
                    variantCode: productCode[1],
                    quantity: 1
                }
            } else {
                this.purchase = {
                    productCode: productCode[0],
                    quantity: 1
                }
            }
            if(!context.state.token) {
                context.commit('changeProgress', true)
                axios
                    .post('/shop-api/carts/new/items', this.purchase )
                    .then(response => (
                        context.commit('updateCart', response.data)
                    ))
                    .catch(()=>{
                        context.commit('changeProgress', false)
                    })

                let cart = {
                    "tokenValue": null,
                        "channel": "",
                        "currency": "",
                        "locale": "",
                        "checkoutState": "",
                        "items": [],
                        "totals": {
                        "total": 0,
                            "items": 0,
                            "taxes": 0,
                            "shipping": 0,
                            "promotion": 0
                    },
                    "payments": [],
                        "shipments": [],
                        "cartDiscounts": []
                }
                context.commit('updateCart', cart)
            } else {
                context.commit('changeProgress', true)
                axios
                    .post('/shop-api/carts/'+this.state.token+'/items', this.purchase)
                    .then(response => (
                        context.commit('updateCart', response.data)
                    ))
                    .catch(()=>{
                        context.commit('changeProgress', false)
                    })
            }
        },
        tryToRecover (context) {
            if (context.state.cart && context.state.cart.checkoutState=='completed') {
                return
            }
            let token = sessionStorage.getItem('cartToken');
            if (token ) {
                context.commit('changeProgress', true)
                axios
                    .get('/shop-api/checkout/'+token)
                    .then(response => {
                        context.commit('updateCart', response.data)
                    })
                    .catch(()=>{
                        console.log('oops..')
                        sessionStorage.removeItem('cartToken')
                        context.commit('changeProgress', false)
                    })
            }
        },
        updateItem (context, item) {
            if(context.state.token && item.length==2) {
                context.commit('changeProgress', true)
                if (item[1] < 1) {
                    axios
                        .delete('/shop-api/carts/'+this.state.token+'/items/'+item[0])
                        .then(response => (
                            context.commit('updateCart', response.data)
                        ))
                        .catch(()=>{
                            context.commit('changeProgress', false)
                        })
                } else {
                    axios
                        .put('/shop-api/carts/'+this.state.token+'/items/'+item[0], {
                            "quantity": item[1]
                        })
                        .then(response => (
                            context.commit('updateCart', response.data)
                        ))
                        .catch(()=>{
                            context.commit('changeProgress', false)
                        })
                }
            }
        },
        updateDelivery(context, method) {
            if(context.state.token) {
                context.commit('changeProgress', true)
                axios
                    .put('/shop-api/checkout/'+this.state.token+'/shipping/'+method[0], {
                        "method": method[1]
                    })
                    .then(() => {
                        if (this.state.cart.payments.length) {
                            axios
                                .put('/shop-api/checkout/'+this.state.token+'/payment/0', {
                                    "method": this.state.cart.payments[0].method.code
                                })
                                .then(()=>{
                                    context.commit('changeProgress', false)
                                }).catch(()=>{
                                    context.commit('changeProgress', false)
                                })
                        } else {
                            context.commit('changeProgress', false)
                        }
                        context.commit('changeProgress', false)
                    })
                    .catch(()=>{
                        context.commit('changeProgress', false)
                    })
            }
        },
        updatePayment(context, method) {
            if(context.state.token) {
                context.commit('changeProgress', true)
                axios
                    .put('/shop-api/checkout/'+this.state.token+'/payment/'+method[0], {
                        "method": method[1]
                    })
                    .then(() => {
                        axios
                            .get('/shop-api/checkout/'+this.state.token)
                            .then(response => {
                                context.commit('updateCart', response.data)
                            })
                            .catch(()=>{
                                context.commit('changeProgress', false)
                            })
                    })
                    .catch(()=>{
                        context.commit('changeProgress', false)
                    })
            }
        },
        requestAddress(context, state) {
            context.commit('toggleDelivery', state)
        },
        complete(context) {
            const payment = this.state.cart.payments[0].method
            const shipment = this.state.cart.shipments[0].method
            let shippingAddress = this.state.cart.shippingAddress
            shippingAddress.firstName = this.state.completeData.firstName
            shippingAddress.lastName = this.state.completeData.lastName
            shippingAddress.phoneNumber = this.state.completeData.phoneNumber
            let billingAddress = shippingAddress
            this.state.cachedCompleteData = false

            context.commit('changeProgress', true)
            axios.put( '/shop-api/checkout/'+this.state.token+'/address', {
                'shippingAddress': shippingAddress,
                'billingAddress': billingAddress
            })
                .then( ()=>{
                    axios.put('/shop-api/checkout/'+this.state.token+'/shipping/0', {
                        "method": shipment.code
                    })
                        .then(()=>{
                            axios
                                .put('/shop-api/checkout/'+this.state.token+'/payment/0', {
                                    "method": payment.code
                                })
                                .then(()=>{
                                    axios
                                        .put('/shop-api/checkout/'+this.state.token+'/complete', {
                                            "email": this.state.completeData.email,
                                            "notes": JSON.stringify({notes:this.state.completeData.notes, pickup:this.state.completeData.pickup})
                                        })
                                        .then( ()=>{
                                            return axios
                                                .get('/shop-api/orders/'+this.state.token)
                                                .then(response=>{
                                                    context.commit('changeProgress', false)
                                                    context.commit('updateCart', response.data)
                                                })
                                                .catch(()=>{
                                                    console.log('Fail :\'(')
                                                    context.commit('changeProgress', false)
                                                })
                                        } )
                                        .catch(()=>{
                                            console.log(':((')
                                            context.commit('changeProgress', false)
                                        })
                                })
                                .catch(()=>{
                                    console.log(':((')
                                    context.commit('changeProgress', false)
                                })
                        } )
                        .catch(()=>{
                            console.log(':((')
                            context.commit('changeProgress', false)
                        })
                })
                .catch(()=>{
                    console.log(':((')
                    context.commit('changeProgress', false)
                })
        },
        updateOrder( context ) {
            context.commit('changeProgress', true)
            axios
                .get('/shop-api/orders/'+this.state.token)
                .then(response=>{
                    context.commit('changeProgress', false)
                    context.commit('updateCart', response.data)
                })
                .catch(()=>{
                    console.log('Fail :\'(')
                    context.commit('changeProgress', false)
                })
        },
        initStripePayment (context, el) {
            context.commit('initStripePayment', el)
        },
        prepareStripePayment( context) {
            context.commit('changeProgress', true)
            context.commit('setStripeError', '')
            return context.state.stripe.stripe.createToken(context.state.stripe.card).then((result)=>{
//            return context.state.stripe.stripe.createSource(context.state.stripe.card).then((result)=>{
                if (result.error) {
                    context.commit('setStripeError', result.error.message)
                    /*
                                        self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
                    */
                }
                else{
                    context.commit('setStripeReply', result)
                    return axios.post('/shop-api/pay/stripe/intent/'+context.state.cart.tokenValue, {
                        stripetoken: context.state.stripe.reply.token.id
                    } )
                        .then((response)=>{
                            context.commit('setStripeClientSecret', response.data.cs)
                            if (response.data.cs.length) {
                                context.state.stripe.stripe.confirmCardPayment(
                                    response.data.cs, {
                                        payment_method: {
                                            card: context.state.stripe.card,
                                            billing_details: {
                                                name: context.state.completeData.firstName+' '+context.state.completeData.lastName,
                                                telephone: context.state.completeData.telephone,
                                            },
                                        },
                                    })
                                    .then(function(result) {
                                        if (result.error) {
                                            context.commit('setStripeError', result.error.message)
                                        }
                                        context.commit('setStripeReply',result)
                                    })
                                    .finally(()=>{
                                        context.commit('changeProgress', false)
                                    });
                            }
                        })
                        .catch((err)=>{
                            context.commit('setStripeError', err.message)
                        })
                        .finally(()=>{
                            context.commit('changeProgress', false)
                        })

                }
            })
            .catch((err) => {
                context.commit('setStripeError', err.message)
                context.commit('changeProgress', false)
            });

        },
        finalizeStripePayment (context) {
            context.commit('changeProgress', true)
            context.commit('setStripeError', '')
            return axios.post('/shop-api/pay/stripe/'+context.state.cart.tokenValue, {
                stripetoken: context.state.stripe.reply.paymentIntent.id
            } )
                .finally(()=>{
                    context.commit('changeProgress', false)
                })

        },
        setPickupTime (context, t) {
            context.commit('setPickupTime', t)
        }

    }
});